import { GroupOption } from '@mews-commander/types';
import { useLocalizeText } from '@mews/framework';
import { createOption } from '@mews-commander/ui';
import {
    DataMappingCategories,
    dataMappingCategoriesMap,
    TEMPLATE_CATEGORY_OPTION_LABEL_PREFIX,
    TEMPLATE_IDENTIFIER_OPTION_LABEL_PREFIX,
} from '../dataMapping/constants';
import { TextKey } from '../../../index';

export const useTemplateDataMappingOptions = (): GroupOption[] => {
    const localizeText = useLocalizeText();

    return Object.entries(dataMappingCategoriesMap).map(([category, identifiers]) => ({
        groupLabel: localizeText({
            textKey: `${TEMPLATE_CATEGORY_OPTION_LABEL_PREFIX}${category as DataMappingCategories}` as TextKey,
        }),
        groupOptions: identifiers.map((identifier) =>
            createOption({
                label: localizeText({ textKey: `${TEMPLATE_IDENTIFIER_OPTION_LABEL_PREFIX}${identifier}` as TextKey }),
                value: identifier,
            })
        ),
    }));
};
